import { render } from "./MensaView.vue?vue&type=template&id=db2d86e0&scoped=true"
import script from "./MensaView.vue?vue&type=script&lang=js"
export * from "./MensaView.vue?vue&type=script&lang=js"

import "./MensaView.vue?vue&type=style&index=0&id=db2d86e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2d86e0"]])

export default __exports__